import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleTranslation = {
  namespaced: true,

  state: {
    name: 'translations',
    translations: []
  },

  mutations,
  getters,
  actions
}

export default moduleTranslation;